import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import useChatStore from "../store/useChatStore";
import { getFAQsAPI, selectFaqAPI } from "../api-services/faq.api";
import ContactButton from "../common/ContactButton";
import { IoIosArrowForward } from "react-icons/io";
import { getComapnyInfo } from "../api-services/company.api";
import { IoChatbubblesSharp } from "react-icons/io5";
import { HiTicket } from "react-icons/hi2";
import { RiCustomerService2Line } from "react-icons/ri";

const HomePage = () => {
  const { setCurrentScreen, setFaqInfo, setInputValue, chatbotTheme } =
    useChatStore();

  const [faqList, setFaqList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [companyInfo, setCompanyInfo] = useState();
  const [loading, setLoading] = useState(false);
  const shopUrl = window.location.href;
  const domain = new URL(shopUrl).host;

  const getFAQs = () => {
    const params = {
      shopId: domain === "localhost:3000" ? "sulopa.myshopify.com" : domain,
      search: searchText,
    };
    setLoading(true);
    getFAQsAPI(params)
      .then((res) => {
        if (res?.message === "Successful") {
          setFaqList(res.payload.list);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getCompanyProfile = () => {
    const params = {
      shopName: domain === "localhost:3000" ? "sulopa.myshopify.com" : domain,
    };
    getComapnyInfo(params).then((res) => {
      if (res?.message === "Successful") {
        setCompanyInfo(res.payload);
      }
    });
  };

  const handleAfterSalesClick = () => {
    setInputValue("");
    setCurrentScreen("orderList");
  };

  const handleAfterTicketRised = () => {
    setInputValue("");
    setCurrentScreen("ticketfetched");
  };

  const handleQuestionClick = (info) => {
    setFaqInfo(info);
    setCurrentScreen("supportInfo");
    const payload = {
      faqUuid: info.uuid,
    };
    selectFaqAPI(payload).then((res) => console.log(res));
  };

  const handleMail = () => {
    setCurrentScreen("mail-us");
  };

  const handleWhatsapp = () => {
    const message = "Hi";
    const encodedMessage = encodeURIComponent(message);
    window.open(
      `https://wa.me/${companyInfo?.whatsAppNumber}?text=${encodedMessage}`,
      "_blank"
    );
  };

  const handleSendMessage = (message) => {
    setCurrentScreen("one-to-one");
  };

  useEffect(() => {
    getFAQs();
  }, [searchText]);

  useEffect(() => {
    getCompanyProfile();
  }, []);

  return (
    <div>
      <div className="chat-body">
        <div>
          <h3
            className="chat-title"
            style={{ fontSize: "28px", fontWeight: "500px" }}
          >
            Hi
          </h3>
          <p
            className="chat-subtitle"
            style={{ color: "white", fontSize: "24px", fontWeight: "500px" }}
          >
            Chat with Lopaa
          </p>
        </div>

        <ContactButton
          handleMail={handleMail}
          handleWhatsapp={handleWhatsapp}
        />

        <div className="chat-option chat-card" onClick={handleAfterSalesClick}>
          <div className="order-button">
            <RiCustomerService2Line size={24} color={chatbotTheme} />
            After Sales Order
          </div>
          <IoIosArrowForward color={chatbotTheme} />
        </div>
        <div className="chat-option chat-card" onClick={handleAfterTicketRised}>
          <div className="fetch-ticket-button" style={{ display: "flex" }}>
            <HiTicket size={24} color={chatbotTheme} />
            Your Tickets
          </div>
          <IoIosArrowForward color={chatbotTheme} />
        </div>
        <div className="chat-option chat-card" onClick={handleSendMessage}>
          <div className="fetch-ticket-button" style={{ display: "flex" }}>
            <IoChatbubblesSharp size={24} color={chatbotTheme} />
            Chat With Agent
          </div>
          <IoIosArrowForward color={chatbotTheme} />
        </div>
        {!loading && faqList?.length === 0 && searchText === "" ? (
          <div style={{ height: "300px" }} />
        ) : (
          <div className="chat-card">
            <div className="chat-search-bar">
              <input
                type="text"
                placeholder="Search for support"
                className="chat-search-input"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              <FiSearch className="chat-search-icon" />
            </div>

            <div className="faq-items">
              {faqList?.length > 0 ? (
                faqList?.map((data) => (
                  <div
                    className="faq-item"
                    onClick={() => handleQuestionClick(data)}
                  >
                    <p>{data.question}</p>
                    <IoIosArrowForward
                      className="faq-icon"
                      color={chatbotTheme}
                    />
                  </div>
                ))
              ) : searchText && !loading ? (
                <p className="faq-not-found">No FAQs match your search </p>
              ) : (
                !loading && (
                  <p className="faq-not-found">No FAQs are available.</p>
                )
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomePage;
